import { CuraParagraph } from '@rededor/cura-react'
import { Show } from '../Show'
import * as S from './styles'

interface Props {
  primaryText?: string
  secondaryText?: string
}

export const LoadingContentDefault = ({
  primaryText,
  secondaryText
}: Props) => {
  return (
    <S.Content>
      <Show when={Boolean(primaryText)}>
        <CuraParagraph size="small" marginBlock="0">
          {primaryText}
        </CuraParagraph>
      </Show>
      <Show when={Boolean(secondaryText)}>
        <CuraParagraph size="small" marginBlock="0">
          <strong>{secondaryText}</strong>
        </CuraParagraph>
      </Show>
    </S.Content>
  )
}
